import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { _ as p } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import h from "../Description/index.js";
import g from "../Heading/index.js";
import f from "../InlineView/index.js";
import n from "../ListView/index.js";
import u from "../PageContainer/index.js";
import '../../index45.css';const _ = "_page-header_1t13u_1", w = "_heading_1t13u_2", d = {
  pageHeader: _,
  heading: w
};
function L(l) {
  const {
    className: m,
    heading: t,
    description: r,
    actions: i,
    breadCrumbs: o,
    info: s,
    wikiLink: c
  } = l;
  return i || o || s || r || t ? /* @__PURE__ */ e(
    u,
    {
      containerAs: "header",
      className: p(
        d.pageHeader,
        m
      ),
      children: /* @__PURE__ */ a(
        n,
        {
          layout: "block",
          spacing: "xl",
          children: [
            /* @__PURE__ */ e(
              f,
              {
                after: (i || c) && /* @__PURE__ */ a(
                  n,
                  {
                    withWrap: !0,
                    spacing: "sm",
                    children: [
                      i,
                      c
                    ]
                  }
                ),
                wrapBreakpoint: "lg",
                children: o
              }
            ),
            /* @__PURE__ */ a(
              n,
              {
                layout: "block",
                children: [
                  /* @__PURE__ */ e(
                    g,
                    {
                      level: 1,
                      className: d.heading,
                      children: t
                    }
                  ),
                  r && /* @__PURE__ */ e(h, { withCenteredContent: !0, children: r })
                ]
              }
            ),
            s
          ]
        }
      )
    }
  ) : null;
}
export {
  L as default
};
